// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xr-1";
export var printerIcon = "_xr-0";